// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4023186a","455":"30dcef0d"}[chunkId] + ".chunk.js";
};